export class BackofficeUserBrandingSettings {
  constructor(
    public sideImageUrl: string = "https://icpublicuploads.s3-eu-west-1.amazonaws.com/global/backoffice/sideImage.png",
    public headerText: string = "Evrideo",
    public windowTitle: string = "Evrideo | The Next Generation of Online Live TV",
    public tabTitlePrefix: string = "Evrideo",
    public loadingImageUrl: string = "https://icpublicuploads.s3-eu-west-1.amazonaws.com/global/backoffice/logo-loader.svg",
    public faviconUrl: string = "https://icpublicuploads.s3-eu-west-1.amazonaws.com/global/backoffice/favicon.png",
    public browserTooSmallImageUrl: string = "https://icpublicuploads.s3-eu-west-1.amazonaws.com/global/backoffice/browserTooSmallImage.png",
  ) {}

  public static FromRawObject(raw: any) {
    return new BackofficeUserBrandingSettings(
      raw.sideImageUrl,
      raw.headerText,
      raw.windowTitle,
      raw.tabTitlePrefix,
      raw.loadingImageUrl,
      raw.faviconUrl,
      raw.browserTooSmallImageUrl,
    );
  }
}
